import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import DataProcessor from './utils/DataProcessor';
import ClubSection from './components/ClubSection';
import PlayerDetail from './components/PlayerDetail';
import TeamDetail from './components/TeamDetail';
import ClubDetail from './components/ClubDetail';

function App() {
  const [clubsData, setClubsData] = useState({});
  const [rawBattingData, setRawBattingData] = useState([]);
  const [rawBowlingData, setRawBowlingData] = useState([]);
  const [teamResultsData, setTeamResultsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const processor = new DataProcessor();
        const data = await processor.processData();
        setClubsData(data.clubs);
        setRawBattingData(data.battingData);
        setRawBowlingData(data.bowlingData);
        setTeamResultsData(data.teamResults);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error loading data:', err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="app">
        <header className="app-header">
          <h1>🏏 Cricket Souvenirs</h1>
          <p>Comprehensive Cricket Statistics and Player Performance Data</p>
        </header>
        <div className="loading">Loading cricket statistics...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app">
        <header className="app-header">
          <h1>🏏 Cricket Souvenirs</h1>
          <p>Comprehensive Cricket Statistics and Player Performance Data</p>
        </header>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/player/:playerName/:statType" element={<PlayerDetail battingData={rawBattingData} bowlingData={rawBowlingData} />} />
        <Route path="/team/:teamName" element={<TeamDetail teamResults={teamResultsData} />} />
        <Route path="/club/:clubName" element={<ClubDetail teamResults={teamResultsData} />} />
        <Route path="/" element={<HomePage clubsData={clubsData} />} />
      </Routes>
    </Router>
  );
}

function HomePage({ clubsData }) {
  const clubs = Object.keys(clubsData).sort().filter(club => club === '12 Stars CC');

  return (
    <div className="app">
      <header className="app-header">
        <h1>🏏 Cricket Souvenirs</h1>
        <p>Comprehensive Cricket Statistics and Player Performance Data</p>
      </header>

      <div className="container">
        <div className="stats-summary">
          <div className="summary-item">
            <span className="summary-label">Clubs</span>
            <span className="summary-value">{clubs.length}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">Teams</span>
            <span className="summary-value">
              {clubs.reduce((acc, club) => acc + Object.keys(clubsData[club]).length, 0)}
            </span>
          </div>
        </div>

        <div className="clubs-container">
          {clubs.map((club) => (
            <ClubSection 
              key={club}
              clubName={club} 
              teamsData={clubsData[club]}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
